import { OffersPromoRepository } from "../Repository/OffersPromoRepository";
import { BannerState } from '../Model/BannerState';



export interface UpdateStateBannerUseCase {
    invoke: (data: BannerState) => Promise<boolean>;
  }
  
  export class UpdateStateBanner implements UpdateStateBannerUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(data: BannerState){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateStateBanner(data);
        return update;
    }
  }